import React from 'react';

export const Card = ({ children, className = '' }) => {
    return (
        <div className={`card ${className}`}>
            {children}
        </div>
    );
};

export const CardHeader = ({ title, description }) => {
    return (
        <div className="card-header">
            <h2 className="card-title">{title}</h2>
            {description && <p className="card-description">{description}</p>}
        </div>
    );
};

export const CardContent = ({ children, className = '' }) => {
    return (
        <div className={`card-content ${className}`}>
            {children}
        </div>
    );
};
